export const SET_MAKE_AI_SEARCH_SUCCESS = 'SET_MAKE_AI_SEARCH_SUCCESS';
export const SET_SELECTED_BULLET_ID = 'SET_SELECTED_BULLET_ID';
export const SET_SELECTED_AI_HISTORY_RES_IDX = 'SET_SELECTED_AI_HISTORY_RES_IDX';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const LOADING_MESSAGE = '请稍等...';

export const DO_AI_SEARCH_RES = 'DO_AI_SEARCH_RES';
export const GET_AI_HISTORY_RES = 'GET_AI_HISTORY_RES';
export const PUSH_QUESTION = 'PUSH_QUESTION';
